export default "__VITE_PUBLIC_ASSET__09a3556e__"